import { Suspense } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { FallbackView } from '../../_metronic/partials';
import { useAuth } from '../contexts/AuthProvider';
import Clientes from '../pages/clientes/Clientes';
import Calendario from '../pages/calendario/Calendario';
import CalendarioNovo from '../pages/calendario/CalendarioNovo';
import Evento from '../pages/eventos/Evento';
import Empresas from '../pages/empresas/Empresas';
import Fisco from '../pages/fisco/Fisco';
import ObrigacaoAcessorias from '../pages/obrigacaoAcessorias/ObrigacaoAcessorias';
import Cnae from '../pages/cnae/Cnae';
import RetencaoFonte from '../pages/retencaoFonte/RetencaoFonte';
import Parametrizacao from '../pages/parametrizacao/Parametrizacao';
import ParametrizacaoModal from '../pages/parametrizacao/ParametrizacaoModal';
import DocumentosRegras from '../pages/documentosRegras/DocumentosRegras';
import Usuarios from '../pages/usuarios/Usuarios';
import UsuariosAdmin from '../pages/usuariosAdmin/Usuarios';
import Mensagens from '../pages/mensagens/Mensagens';
import Importar from '../pages/importar/Importar';
import ImportarNovo from '../pages/importar/ImportarNovo';
import RelatorioSelecionarCliente from '../pages/relatorios/RelatorioSelecionarCliente';
import Relatorio from '../pages/relatorios/Relatorio';
import Permissoes from '../pages/permissoes/Permissoes';
import RelatorioErro from '../pages/relatorios/RelatorioErro';
import RelatorioAviso from '../pages/relatorios/RelatorioAviso';
import RelatorioRecomendacao from '../pages/relatorios/RelatorioRecomendacao';
import RelatorioMatch from '../pages/relatorios/RelatorioMatch';
import RelatorioPendentes from '../pages/relatorios/RelatorioPendentes';
import RelatorioConciliado from '../pages/relatorios/RelatorioConciliado';

export function PrivateRoutes() {
  const { usuario } = useAuth();

  return (
    <Suspense fallback={<FallbackView />}>
      {usuario?.perfil === 'Analista' &&
        <Switch>
          <Route exact path='/empresas' component={Empresas} />
          <Route exact path='/importar' component={Importar} />
          <Route exact path='/importar/novo' component={ImportarNovo} />
          <Route exact path='/relatorioSelecionarCliente' component={RelatorioSelecionarCliente} />
          <Route exact path='/relatorio/:id' component={Relatorio} />
          <Route exact path='/Relatorio/:id/Erro' component={RelatorioErro} />
          <Route exact path='/Relatorio/:id/Aviso' component={RelatorioAviso} />
          <Route exact path='/Relatorio/:id/Recomendacao' component={RelatorioRecomendacao} />
          <Route exact path='/Relatorio/:id/Match' component={RelatorioMatch} />
          <Route exact path='/Relatorio/:id/Pendente' component={RelatorioPendentes} />
          <Route exact path='/Relatorio/:id/Conciliado' component={RelatorioConciliado} />
          <Redirect from='/login' to='/relatorioSelecionarCliente' />
          <Redirect exact from='/' to='/relatorioSelecionarCliente' />
          <Redirect to='error/404' />
        </Switch>
      }

      {usuario?.perfil === 'Administrador' &&
        <Switch>
          <Route exact path='/usuarios' component={UsuariosAdmin} />
          <Route exact path='/empresas' component={Empresas} />
          <Route exact path='/importar' component={Importar} />
          <Route exact path='/importar/novo' component={ImportarNovo} />
          <Route exact path='/relatorioSelecionarCliente' component={RelatorioSelecionarCliente} />
          <Route exact path='/relatorio/:id' component={Relatorio} />
          <Route exact path='/Relatorio/:id/Erro' component={RelatorioErro} />
          <Route exact path='/Relatorio/:id/Aviso' component={RelatorioAviso} />
          <Route exact path='/Relatorio/:id/Recomendacao' component={RelatorioRecomendacao} />
          <Route exact path='/Relatorio/:id/Match' component={RelatorioMatch} />
          <Route exact path='/Relatorio/:id/Pendente' component={RelatorioPendentes} />
          <Route exact path='/Relatorio/:id/Conciliado' component={RelatorioConciliado} />
          <Redirect from='/login' to='/relatorioSelecionarCliente' />
          <Redirect exact from='/' to='/relatorioSelecionarCliente' />
          <Redirect to='error/404' />
        </Switch>
      }

      {usuario?.perfil === 'Master' &&
        <Switch>
          <Route exact path='/clientes' component={Clientes} />
          <Route exact path='/eventos' component={Evento} />
          <Route exact path='/fisco' component={Fisco} />
          <Route exact path='/documentosRegras' component={DocumentosRegras} />
          <Route exact path='/mensagens' component={Mensagens} />
          <Route exact path='/obrigacaoAcessorias' component={ObrigacaoAcessorias} />
          <Route exact path='/cnae' component={Cnae} />
          <Route exact path='/retencaoFonte' component={RetencaoFonte} />
          <Route exact path='/usuarios' component={Usuarios} />
          <Route exact path='/permissoes' component={Permissoes} />
          <Route exact path='/parametrizacoes' component={Parametrizacao} />
          <Route exact path='/parametrizacoes/novo' component={ParametrizacaoModal} />
          <Route exact path='/parametrizacoes/editar/:id' component={ParametrizacaoModal} />
          <Route exact path='/calendario' component={Calendario} />
          <Route exact path='/calendario/novo' component={CalendarioNovo} />
          <Route exact path='/calendario/editar/:id' component={CalendarioNovo} />
          <Route exact path='/Relatorio/:id/Conciliado' component={RelatorioConciliado} />
          <Redirect from='/login' to='/clientes' />
          <Redirect exact from='/' to='/clientes' />
          <Redirect to='error/404' />
        </Switch>
      }
    </Suspense >
  )
}
